import React, { useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { useThemeMode } from '../context/ThemeMode/ThemeModeProvider';
import { createGritTheme } from './theme';

export const GritThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { resolvedMode } = useThemeMode();
  const theme = useMemo(() => createGritTheme(resolvedMode), [resolvedMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
